// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"231":"blueprint-icons-split-paths-by-size-loader","824":"blueprint-icons-all-paths-loader"}[chunkId] || chunkId) + "." + {"223":"dbb2c1d4","231":"a365b977","541":"b3005307","743":"e03ed974","824":"a2d45b87","825":"4790bab9"}[chunkId] + ".chunk.js";
};